import React from "react";
// import { NavLink } from 'react-router-dom';
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';

function NotFound() {
    return(
        // <div className="NotFoundPage p-3 bg-light d-flex justify-content-center align-items-center" style={{height: 100 + 'vh'}} >
        //     <div className="row">
        //         <div className="col-lg-12">
        //             <h3 className="text-primary mb-4">Opps!</h3>
        //             <p>Nothing Found</p>
        //         </div>
        //     </div>
        // </div>
        <div className="position-relative p-5 text-center text-muted bg-body border border-dashed rounded-5">
            {/* <button type="button" className="position-absolute top-0 end-0 p-3 m-3 btn-close bg-secondary bg-opacity-10 rounded-pill" aria-label="Close"></button> */}
            <Icon className="Icon" icon={Icon(eyeOff)} size={25}/>
            <h1 className="text-body-emphasis">Placeholder jumbotron</h1>
                <p className="col-lg-6 mx-auto mb-4">
                    This faded back jumbotron is useful for placeholder content. It's also a great way to add a bit of context to a page or section when no content is available and to encourage visitors to take a specific action.
                </p>
                {/* <NavLink to="/forgot-password" className="btn btn-primary px-5 mb-5">Back</NavLink> */}
        </div>
    );
}
export default NotFound;